import React, { useEffect, useState } from 'react'

import { getImageUrl } from 'utils/ImageUrl'

import { CardType, defaultCard } from 'types/deck'

import CardService from 'services/card.service'

import PageWrapper from 'components/misc/PageWrapper'
import CardBanner from 'components/misc/CardBanner'
import BasicCard from 'components/card/BasicCard'

import styles from './404.module.scss'

const NotFoundPage = () => {
  const [loading, setLoading] = useState(true)
  const [randomCommander, setRandomCommander] = useState<CardType>(defaultCard)

  useEffect(() => {
    CardService.listCardsOnly({
      superTypes: 'Legendary',
      types: 'Creature',
      random: true,
      formatLegality: 3,
    })
      .then(res => setRandomCommander(res[0]))
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }, [])

  return (
    <PageWrapper title="Not Found - Archidekt" robots="noindex">
      <CardBanner
        height="300px"
        artist
        src={randomCommander ? getImageUrl(randomCommander.setCode, randomCommander.uid, false, 'art_crop') : ''}
        title={<p>Page not found</p>}
      />
      <div className={styles.content}>
        <h2> But while you're here... </h2>
        <h4> Have you considered making an EDH deck with this commander? </h4>
        <BasicCard
          cardDataPending={loading}
          nameOnPlaceholder={false}
          textOnPlaceholder={false}
          card={randomCommander}
        />
      </div>
    </PageWrapper>
  )
}

export default NotFoundPage
